import { get as _get } from 'lodash';
import { createSelector } from 'reselect';

import config from 'config/index';
import { selectFirestore } from 'services/selectors';

import { getPartnersKey, getPartnersValueKey } from '../utils';

const defaultPartnersData = {
    value: '',
};

const selectPartners = state => state.partners;

export const selectPartnersFetching = createSelector(selectPartners, ({ fetching }) => fetching);

export const selectPartnersForUpdate = createSelector(selectFirestore, firestore => {
    const data = config.app.languages.reduce((acc, lang) => {
        const entry = _get(firestore.data, getPartnersKey(lang), defaultPartnersData);
        acc[getPartnersValueKey(lang)] = entry.value;

        return acc;
    }, {});

    return data;
});
